"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntitlementsSuccessActionWatcher = void 0;
const effects_1 = require("redux-saga/effects");
const luxon_1 = require("luxon");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const datasets_1 = require("companion-app-components/flux/datasets");
function* redirectUserToQuickenSubscription(entitlement) {
    var _a, _b;
    const entitlements = yield (0, effects_1.select)(entitlements_1.entitlementsSelectors.getEntitlements);
    const activeEntitlements = yield (0, effects_1.select)(entitlements_1.entitlementsSelectors.getActiveEntitlements);
    const localTime = luxon_1.DateTime.local();
    core_1.crashReporterInterface.reportError(Error('no active entitlement found'), (event) => event.addMetadata('custom', {
        entitlement,
        activeEntitlements,
        entitlements,
        localTime,
    }));
    yield (0, effects_1.put)(auth_1.authActions.authLogout({ reason: 'AUTH_LOGOUT_UNAUTHORIZED' }, { context: 'no entitlement quicken' }));
    window.location.replace((_b = (_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.pick_your_plan_url) !== null && _b !== void 0 ? _b : '');
}
function* getEntitlementsSuccessActionWatcher() {
    yield (0, effects_1.takeLatest)([datasets_1.datasetsActions.getDatasetEntitlementsSuccess,
        entitlements_1.entitlementsActions.getEntitlementsSuccess], function* getEntitlementsSuccess(action) {
        yield (0, effects_1.delay)(3000);
        const datasets = yield (0, effects_1.select)(datasets_1.datasetsSelectors.getEntitledDatasets);
        if (action.type === entitlements_1.entitlementsActions.getEntitlementsSuccess.type) {
            const userEntitlement = yield (0, effects_1.select)(entitlements_1.entitlementsSelectors.getTopTierEntitlement);
            const sharedDatasets = datasets.filter((objDataset) => objDataset.shared);
            if (!userEntitlement &&
                ((datasets.size > 0 && sharedDatasets.size === 0) || datasets.size === 0)) {
                yield (0, effects_1.call)(redirectUserToQuickenSubscription, userEntitlement);
            }
        }
        else {
            const currentDatasetId = yield (0, effects_1.select)(auth_1.authSelectors.getDatasetId);
            const selectedDataset = currentDatasetId ? datasets.find(({ id }) => id === currentDatasetId) : undefined;
            const entitlement = selectedDataset === null || selectedDataset === void 0 ? void 0 : selectedDataset.entitlements;
            const entitledDatasetsLoadPending = yield (0, effects_1.select)(datasets_1.datasetsSelectors.getEntitledDatasetsLoadPending);
            if (!entitlement && !entitledDatasetsLoadPending) {
                yield (0, effects_1.call)(redirectUserToQuickenSubscription, entitlement);
            }
        }
    });
}
exports.getEntitlementsSuccessActionWatcher = getEntitlementsSuccessActionWatcher;
exports.default = [
    getEntitlementsSuccessActionWatcher,
];
